import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useDefaultLayoutProps } from '../../../layouts/DefaultLayout/useProps'
import NotFoundTemplate, { NotFoundTemplateProps } from '../../../templates/NotFound'

function UnavailablePage() {
  const { t } = useTranslation()
  const layoutProps = useDefaultLayoutProps()

  const notFoundProps: NotFoundTemplateProps = useMemo(
    () => ({
      layout: layoutProps,
      title: t('unavailable.title'),
    }),
    [layoutProps, t]
  )

  return <NotFoundTemplate {...notFoundProps} />
}

export default UnavailablePage
